export const isApprovedMember = (user) => String(user?.ismember || "").toLowerCase() === "yes";

export const isApprovedCompany = (user) => String(user?.company_status || user?.company?.status || "").toLowerCase() === "approved";

export const hasApprovedSiteAccess = (user) => isApprovedMember(user) || isApprovedCompany(user);